import { CircularProgressCenter, useDeviceDimensions } from "igfd-ui";

import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { Box } from "@mui/material";

import { useAuthState } from "igfd-commons/src/auth";

import IgfdBlackLogo from "@dashboard/assets/images/logo/logo-name-black.png";
import { SideAsset } from "@dashboard/components/auth/SideAsset";

/**
 * Before authentication, we show login / signup pages.
 * @returns
 */
export const UnauthenticatedLayout = () => {
  const { loading, user } = useAuthState();

  const { isMobile } = useDeviceDimensions();

  if (loading) {
    return <CircularProgressCenter />;
  }

  if (user) {
    // User was already logged in. Take them to the home page.
    return <Navigate to="/" />;
  }

  // The following the login / signup / forgot password pages.
  // the exact page to be shown is determined by the router.
  return (
    <Box
      display={"flex"}
      flexDirection={isMobile ? "column" : "row"}
      sx={{ height: "100vh", overflowY: !isMobile ? "hidden" : undefined }}
    >
      {isMobile ? <MobileLogo /> : <SideAsset />}
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          overflowY: !isMobile ? "auto" : undefined,
        }}
        component={"main"}
      >
        <Box sx={{ margin: "auto", width: 450, paddingY: 4, paddingX: 2 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

const MobileLogo = () => {
  return (
    <Box
      sx={{
        margin: "0 auto",
        width: 160,
        maxWidth: 240,
        paddingTop: 4,
      }}
    >
      <img style={{ objectFit: "cover", width: "100%" }} src={IgfdBlackLogo} />
    </Box>
  );
};
